<template>
	<div class="popup-info">
		<div class="popup-info__content">
			<h3 class="popup-info__title popup__title">
				СПАСИБО, ВАШЕ ВИДЕО<br> ОТПРАВЛЕНО НА МОДЕРАЦИЮ.
			</h3>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Thank',
		methods: {
			closePopup() {
				this.$store.commit('SET_POPUP', {name: false});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Thank.vue?2b56ec58